import styled from "styled-components";
import { Typography } from "antd";

const { Title } = Typography;

export const StyledDiv = styled.div`
  position: relative;
  text-align: center;
`;

export const StyledHeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
`;

export const StyledWrapper = styled.div`
  height: 270px;
`;

export const StyledHeader = styled(Title)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
`;
